import React from 'react';
import { compose, withState } from 'recompose';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import WidgetModel from '@mm/state/model/WidgetModel';
import WidgetCRUDActions from '@mm/state/actions/WidgetCRUDActions';
import { uploadImage } from '@mm/state/actions/uploadActions';
import OptinImageView from '../Components/OptinImageView';

type PropsFromWithState = {
  imageUrl: string;
  setImageUrl: (val: string) => string;
};

type PropsFromDispatch = ReturnType<typeof mapDispatchToProps>;

type InnerProps = PropsFromDispatch & PropsFromWithState;
type OuterProps = {
  imageWidget: WidgetModel;
  onRemoteWidgetUpdated: () => void;
};

type OwnProps = PropsFromWithState & OuterProps;

const mapDispatchToProps = (
  dispatch: Dispatch<StoreState>,
  ownProps: OwnProps,
) => ({
  uploadImage: async img64 => {
    const { setImageUrl, imageWidget, onRemoteWidgetUpdated } = ownProps;
    const assetId = await dispatch(uploadImage(img64));

    const nextConfig = Object.assign({}, imageWidget.config, { assetId });
    const nextWidget = Object.assign({}, imageWidget, { config: nextConfig });

    const { file } = await dispatch(WidgetCRUDActions.update(nextWidget));

    setImageUrl(file);
    onRemoteWidgetUpdated();
  },
  removeImage: async () => {
    const { setImageUrl, imageWidget, onRemoteWidgetUpdated } = ownProps;

    const nextConfig = Object.assign({}, imageWidget.config, { assetId: null });
    const nextWidget = Object.assign({}, imageWidget, { config: nextConfig });

    const { file } = await dispatch(WidgetCRUDActions.update(nextWidget));

    setImageUrl(file);
    onRemoteWidgetUpdated();
  },
});

const enhance = compose<InnerProps, OuterProps>(
  withState(
    'imageUrl',
    'setImageUrl',
    ({ imageWidget }: OuterProps) => imageWidget && imageWidget.file,
  ),
  connect(null, mapDispatchToProps),
);

export default enhance(OptinImageView);
